import React from 'react';
import cn from 'clsx';
import { useDeviceType, Button } from '@cian/ui-kit';
import { setAuthorizedModal } from 'shared/redux/landingSlice';
import styles from './styles.css';

import { IButton } from 'shared/types/common/offer';
import { ETestIds } from 'shared/constants/testIds';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAuthorized } from '../../../../selectors/user';
import { useTracking } from '../../../../utils/tracking/useTracking';

export interface IOfferBtnProps extends IButton {}
//TODO добавить мапу цветов кнопки когда будет настройка с бэком + разницу действий кнопки
// ссылка или модальное окно
export const OfferBtn: React.FC<IOfferBtnProps> = ({
  text,
  theme,
  path,
  authorizationRequired,
  bankName,
  analyticEventKey,
  isMultiOffer,
  place,
}) => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const { trackRedirect, trackClickOnOfferButton } = useTracking();

  const isAuthorized = useSelector(selectIsAuthorized);

  const handleClick = () => {
    trackClickOnOfferButton({
      place: Number(place),
      bank: bankName,
      isMultiOffer: Boolean(isMultiOffer),
      type: analyticEventKey,
    });
    if (!isAuthorized && authorizationRequired) {
      dispatch(
        setAuthorizedModal({ isOpen: true, pathForRedirect: path, typeForRedirect: analyticEventKey, bankName }),
      );

      return;
    }

    trackRedirect(bankName, analyticEventKey);
    window.open(path, '_self');
  };

  return (
    <div className={cn(styles['btn'], styles[deviceType])}>
      <Button theme={theme} onClick={handleClick} fullWidth data-testid={ETestIds.OfferCardBtn}>
        {text}
      </Button>
    </div>
  );
};
